import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
const { WizSpin, WizCard, WizForm, WizRow, WizCol } = component_tool
const { WizContainer } = framework_tool
const { Session } = utils_tool
import { WizBraftEditorPlus } from '@/containers/common'

const findParamRecord = (history) => {
    let record = {}
    if (history.location && history.location.pathname === '/integrationCounseling/manager/onlineNotification/lookNotification') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('lookNotification', record)
        } else {
            record = Session.get('lookNotification') || {}
        }
    }
    return record
}

class LookNotification extends WizContainer {

    componentName = 'LookNotification'

    constructor(props) {
        super(props)
        let record = findParamRecord(props.history)
        this.state = {
            record
        }
    }

    _componentDidMount() {
        this._detail()
    }

    _detail = () => {
        const { processContentId, recordId } = this.state.record
        this.doAction({
            path: 'counselingProcess/noticeDetail',
            payload: {
                key: 'noticeDetail@' + recordId,
                apiParams: {
                    tutorContentId: processContentId,
                    id: recordId
                }
            }
        })
    }

    render() {
        let { detail, counselingProcessLoading } = this.props
        let { data } = detail
        let columns = [{
            title: '内训资料包',
            name: 'fileId',
            dataIndex: 'fileId',
            formItem: {
                type: 'custom',
                render: (r, f) => {
                    let url = r && r.fileId ? getOssFilePath(r.fileId) : ''
                    let fileName = r && r.fileName ? r.fileName : ''
                    return <a href={url} style={{ color: '#1890ff' }}>{fileName}</a>
                }
            }
        },
        ]
        let formProps = {
            ref: 'form',
            columns,
            record: data,
            preview: null,
            footer: false,
            formItemLayout: {
                labelCol: { span: 4 },
                wrapperCol: { span: 17 }
            },
            style: { maxWidth: '100%', width: '100%' }
        }
        return (
            <WizSpin spinning={counselingProcessLoading} >
                <WizCard title='查看启动通知'>
                    <div style={{ textAlign: 'center', color: 'red', fontSize: 24, margin: 16 }}>{'启动通知'}</div>
                    <WizRow style={{ marginBottom: 30 }}>
                        <WizCol offset={3} span={18}>
                            <div dangerouslySetInnerHTML={{ __html: data ? data.startDetail : '' }} ></div>
                        </WizCol>
                    </WizRow>
                    <WizForm {...formProps} />
                </WizCard>
            </WizSpin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { counselingProcess } = state
    const { recordId } = findParamRecord(ownProps.history)
    const detail = modelUtils.getModelEntity(counselingProcess, 'noticeDetail@' + recordId)
    const loading = modelUtils.getLoadingState(state, 'counselingProcess')
    return {
        detail,
        ...loading
    }
}

export default connect(mapStateToProps)(LookNotification)


